// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';
import { pushTrackerEvent } from '../_googleTagManager';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'leaf__info';
const body = $('body');

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class LeafInfo {
  constructor(el) {
    this.el = el;

    if ($('.leaf-overlay-mobile').length === 0) {
      body.append('<div class="leaf-overlay-mobile"><div class="leaf-overlay-mobile__content"></div></div>');
    }

    $(el).on('click', (e) => {
      e.preventDefault();
      const label = $(el).attr('data-location');
      const currentPos = $(el).closest('.leaf').offset().top;

      if ($(el).hasClass('open')) {
        $(el).removeClass('open');
        $(el).closest('.locations-catalog__item').removeClass('is-white-bg');

        if ($(window).width() >= 576) {
          if ($('.locations-catalog--map-visible').length >= 1) {
            $(el).next().slideUp(250);
          }
        }

      } else {
        $('.leaf__overlay').removeClass('open');
        $(el).addClass('open');
        $(el).closest('.locations-catalog__item').addClass('is-white-bg');

        if ($(window).width() >= 576) {
          if ($('.locations-catalog--map-visible').length >= 1) {
            $(el).next().slideDown(250);
          }
        }

        document.querySelector('body').classList.remove('leaf-overlay-mobile-is-open');
        document.querySelector('.leaf-overlay-mobile').classList.remove('is-open');
      }

      let cloneLeaf = $(el).closest('.leaf').clone();
      $('.leaf-overlay-mobile__content').html(cloneLeaf);
      $('.leaf-overlay-mobile').toggleClass('is-open');

      document.querySelector('body').classList.add('leaf-overlay-mobile-is-open');
      document.querySelector('.leaf-overlay-mobile').style.setProperty('--leaf-overlay-top', `${currentPos}px`);

      pushTrackerEvent('locationLeafOverlay', {
        'sector': label,
      });
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new LeafInfo(el));

  $(document).on('click', '.leaf-overlay-mobile .leaf__info' , function(e) {
    $('.leaf__info').removeClass('open');
    $('.leaf__overlay').removeClass('open');
    $('.leaf-overlay-mobile').removeClass('is-open');

    $('.locations-catalog--map-visible .leaf__overlay').css('display', 'none');
  });

  $(document).on('click', function(e) {
    if ($(window).width() < 576) {
      if (!e.target.classList.contains('.leaf__info') && !e.target.closest('.leaf__info') && !e.target.closest('.leaf-overlay-mobile__content .leaf')) {
        $('.leaf-overlay-mobile .leaf__info').trigger('click');
      }
    }
  });

  $(window).on('resize', function() {
    if ($(window).width() > 576) {
      if (document.querySelector('.leaf-overlay-mobile')) {
        document.querySelector('.leaf-overlay-mobile').style.removeProperty('--leaf-overlay-top');
      }
    } else {
      if (document.querySelector('.locations-catalog__item .leaf__info.open')) {
        const currentPos = $('.leaf__info.open').closest('.leaf').offset().top;
        document.querySelector('.leaf-overlay-mobile').style.setProperty('--leaf-overlay-top', `${currentPos}px`);
      }
    }
  });
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
